import React from 'react';
import { useI18n } from '../utilities/i18n';

function LanguageSwitch({ variant = 'header' }) {
  const { lang, setLang, t } = useI18n();

  return (
    <div className={`languageSwitch languageSwitch--${variant}`} onClick={(e) => e.stopPropagation()}>
      {variant === 'menu' ? <span className="languageSwitchLabel">{t('language')}</span> : null}
      <div className="languageSwitchGroup" role="group" aria-label={t('language')}>
        <button
          type="button"
          className={`languageSwitchBtn${lang === 'ru' ? ' is-active' : ''}`}
          onClick={() => setLang('ru')}
        >
          RU
        </button>
        <button
          type="button"
          className={`languageSwitchBtn${lang === 'en' ? ' is-active' : ''}`}
          onClick={() => setLang('en')}
        >
          EN
        </button>
      </div>
    </div>
  );
}

export default LanguageSwitch;
